import { render, staticRenderFns } from "./IconColumnRight.vue?vue&type=template&id=4a6dbee0&"
import script from "./IconColumnRight.vue?vue&type=script&lang=js&"
export * from "./IconColumnRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6dbee0')) {
      api.createRecord('4a6dbee0', component.options)
    } else {
      api.reload('4a6dbee0', component.options)
    }
    module.hot.accept("./IconColumnRight.vue?vue&type=template&id=4a6dbee0&", function () {
      api.rerender('4a6dbee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconColumnRight.vue"
export default component.exports